import axios from "axios";
import { StockOptionsFlowSentiment, StockOptionsPutCallRatio, StockOptionsInTheMoney } from "@/models/stock-options";
import { ListQueryParams } from "@/models/table";

export const getStockOptionsInterestingFlow = async (params: ListQueryParams) => {
    const { page_size, page, filter_options, signal, universe_id, next_page_url } = params;

    const url = next_page_url || `/interface/api/options/tradingitem/${universe_id}/list/unusual_activity_flow`;
    const defaultParams = next_page_url ? {} : { page_size, page, ...filter_options };

    const res = await axios.get(url, {
        params: {
            ...defaultParams,
        },
        signal,
    });

    res.data.rows = res.data.rows.map((row) => ({
        ...row,
        reason: row.reason.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    }));
    return res.data;
};

export const getStockOptionsFlowSentiment = async (stockId: number) => {
    const res = await axios.get<StockOptionsFlowSentiment>(`/API/v2/id/${stockId}/options/flow_sentiment`);

    return res.data;
};

export const getStockOptionsPutCallRatio = async (tradingItemId: number, expiry_days_forward: number) => {
    const res = await axios.get<StockOptionsPutCallRatio>(`/interface/api/options/tradingitem/${tradingItemId}/pcr`, { params: { expiry_days_forward } });

    return res.data;
};

export const getStockOptionsInTheMoney = async (tradingItemId: number, price: string, expiry_days_forward: number) => {
    const res = await axios.get<StockOptionsInTheMoney>(`/interface/api/options/tradingitem/${tradingItemId}/itm`, {
        params: {
            price,
            expiry_days_forward,
        },
    });

    return res.data;
};

export const getPutCallRatioData = async (tradingItemId: number, from?: string) => {
    const res = await axios.get<{ PCR: [number, number][]; obfuscated?: boolean; ts_shortened?: boolean }>(`/interface/api/options/tradingitem/${tradingItemId}/pcr_history`, {
        params: { from },
    });

    return res.data;
};

export const getStockOptionsMatrix = async (stockId: number, days_back?: number, showAllData?: boolean) => {
    const params = days_back ? { days_back } : {};
    const res = await axios.get(`/interface/api/options/tradingitem/${stockId}/options/data${showAllData ? "?all_data" : ""}`, {
        params,
    });

    return res.data;
};
